// ---------------------------------------------------------------------------
// เมนู sidebar ของ /admin และเมนูล่างของ /app
// แต่ละรายการผูกกับ feature module ถ้าโมดูลถูกปิด เมนูจะหายไปเอง
// module: null = แสดงเสมอ
// ---------------------------------------------------------------------------

export const ADMIN_MENU = [
  {
    group: "ภาพรวม",
    groupEn: "Overview",
    items: [
      { to: "/admin", label: "แดชบอร์ด", labelEn: "Dashboard", icon: "dashboard", module: null, exact: true },
      { to: "/admin/modules", label: "จัดการโมดูล", labelEn: "Module Manager", icon: "modules", module: null },
    ],
  },
  {
    group: "ลูกค้า",
    groupEn: "Customers",
    items: [
      { to: "/admin/customers", label: "รายชื่อลูกค้า", labelEn: "Customers", icon: "users", module: "crm" },
      { to: "/admin/leads", label: "กระดานลีด", labelEn: "Lead Board", icon: "target", module: "crm" },
      { to: "/admin/membership", label: "สมาชิก & แต้ม", labelEn: "Membership", icon: "badge", module: "membership" },
    ],
  },
  {
    group: "แชท & ออเดอร์",
    groupEn: "Omnichannel",
    items: [
      { to: "/admin/chat", label: "กล่องแชทรวม", labelEn: "Chat Inbox", icon: "chat", module: "chat" },
      { to: "/admin/orders", label: "จัดการออเดอร์", labelEn: "Orders", icon: "cart", module: "oms" },
      { to: "/admin/slips", label: "ตรวจสลิป", labelEn: "Verified Slip", icon: "checkSquare", module: "slip" },
      { to: "/admin/campaigns", label: "แคมเปญ", labelEn: "Campaigns", icon: "megaphone", module: "campaign" },
    ],
  },
  {
    group: "การจอง",
    groupEn: "Booking",
    items: [
      { to: "/admin/calendar", label: "ปฏิทินรวม", labelEn: "Master Calendar", icon: "calendar", module: "booking" },
      { to: "/admin/timeline", label: "ไทม์ไลน์ทรัพยากร", labelEn: "Resource Timeline", icon: "compass", module: "resource" },
      { to: "/admin/appointments", label: "รายการนัดหมาย", labelEn: "Appointments", icon: "calendarAlt", module: "booking" },
    ],
  },
  {
    group: "สินค้า & ทรัพย์สิน",
    groupEn: "Inventory & Assets",
    items: [
      { to: "/admin/catalog", label: "สินค้า & บริการ", labelEn: "Catalog", icon: "tags", module: "catalog" },
      { to: "/admin/assets", label: "ทะเบียนทรัพย์สิน", labelEn: "Asset Register", icon: "car", module: "fleet" },
      { to: "/admin/inventory", label: "คุมสต็อก", labelEn: "Inventory", icon: "box", module: "inventory" },
      { to: "/admin/pos", label: "ขายหน้าร้าน (POS)", labelEn: "POS", icon: "receipt", module: "pos" },
    ],
  },
  {
    group: "การเงิน & เอกสาร",
    groupEn: "Finance",
    items: [
      { to: "/admin/billing", label: "ใบเสนอราคา / ใบแจ้งหนี้", labelEn: "Billing", icon: "card", module: "billing" },
      { to: "/admin/payments", label: "Payment Link & ธุรกรรม", labelEn: "Payments", icon: "link", module: "billing" },
      { to: "/admin/installments", label: "ผ่อนชำระ & สินเชื่อ", labelEn: "Installments", icon: "chartLine", module: "installment" },
      { to: "/admin/commissions", label: "คอมมิชชัน", labelEn: "Commissions", icon: "money", module: "commission" },
      { to: "/admin/contracts", label: "สัญญาอิเล็กทรอนิกส์", labelEn: "e-Contract", icon: "fileText", module: "contract" },
      { to: "/admin/field-service", label: "ใบสั่งงานช่าง", labelEn: "Field Service", icon: "wrench", module: "field_service" },
      { to: "/admin/etax", label: "ใบกำกับภาษีอิเล็กทรอนิกส์", labelEn: "e-Tax Invoice", icon: "fileText", module: "etax" },
      { to: "/admin/online-payment", label: "รับชำระเงินออนไลน์", labelEn: "Online Payment", icon: "card", module: "online_payment" },
    ],
  },
  {
    group: "ตั้งค่า",
    groupEn: "Settings",
    items: [
      { to: "/admin/subscription", label: "แพ็กเกจ & การชำระเงิน", labelEn: "Subscription", icon: "card", module: null, always: true },
      { to: "/admin/addons", label: "ฟีเจอร์เสริม & Point", labelEn: "Add-ons & points", icon: "gift", module: null, always: true },
      { to: "/admin/export", label: "Export ข้อมูล & API", labelEn: "Data export & API", icon: "download", module: "data_export" },
      { to: "/admin/branding", label: "แบรนด์ร้านเอง", labelEn: "Branding", icon: "badge", module: "white_label" },
      { to: "/admin/organization", label: "ข้อมูลองค์กร", labelEn: "Organization", icon: "building", module: null },
      { to: "/admin/branches", label: "สาขา", labelEn: "Branches", icon: "pin", module: null },
      { to: "/admin/staff", label: "พนักงาน", labelEn: "Staff", icon: "staff", module: null },
      { to: "/admin/roles", label: "บทบาท & สิทธิ์", labelEn: "Roles", icon: "lock", module: null },
      { to: "/admin/notifications", label: "ตั้งค่าแจ้งเตือน", labelEn: "Notifications", icon: "bell", module: null },
      { to: "/admin/faqs", label: "คำถามที่พบบ่อย", labelEn: "FAQ", icon: "question", module: null },
    ],
  },
];

// เมนูฝั่งลูกค้า (เว็บเดสก์ท็อปเต็มรูปแบบ ไม่มีเวอร์ชันมือถือแยก)
export const CUSTOMER_MENU = [
  {
    group: "หน้าหลัก",
    groupEn: "Main",
    items: [
      { to: "/app", label: "หน้าหลัก", labelEn: "Dashboard", icon: "home", module: null, exact: true },
      { to: "/app/store", label: "บริการ", labelEn: "Services", icon: "tag", module: "catalog" },
      { to: "/app/bookings", label: "การจอง", labelEn: "Bookings", icon: "calendar", module: "booking" },
      { to: "/app/billing", label: "บิล & การชำระเงิน", labelEn: "Billing", icon: "card", module: "billing" },
    ],
  },
  {
    group: "บัญชีของฉัน",
    groupEn: "My account",
    items: [
      { to: "/app/wallet", label: "กระเป๋าเงิน & แต้ม", labelEn: "Wallet & Points", icon: "money", module: "membership" },
      { to: "/app/activity", label: "ประวัติการใช้บริการ", labelEn: "Activity", icon: "history", module: null },
      { to: "/app/contracts", label: "สัญญา & ค่างวด", labelEn: "Contracts", icon: "fileText", module: "contract" },
      { to: "/app/documents", label: "เอกสารของฉัน", labelEn: "Documents", icon: "folder", module: null },
      { to: "/app/profile", label: "ข้อมูลส่วนตัว", labelEn: "Profile", icon: "user", module: null },
    ],
  },
  {
    group: "ติดต่อ & แจ้งเตือน",
    groupEn: "Support",
    items: [
      { to: "/app/slip-upload", label: "แจ้งโอนเงิน", labelEn: "Upload Slip", icon: "checkSquare", module: "slip" },
      { to: "/app/chat", label: "แชทกับเจ้าหน้าที่", labelEn: "Live Chat", icon: "chat", module: "chat" },
      { to: "/app/notifications", label: "การแจ้งเตือน", labelEn: "Notifications", icon: "bell", module: null },
      { to: "/app/help", label: "ศูนย์ช่วยเหลือ", labelEn: "Help Center", icon: "question", module: null },
    ],
  },
];

// กรองเมนูตามโมดูลที่เปิดอยู่
export const filterByModules = (items, enabledModules) =>
  items.filter((item) => !item.module || enabledModules.includes(item.module));

export const filterGroupsByModules = (groups, enabledModules) =>
  groups.map((group) => ({ ...group, items: filterByModules(group.items, enabledModules) })).filter((group) => group.items.length > 0);
